import React, { PureComponent } from "react";
import SocialContainer from "../Social/SocialContainer";
import AuthorsComponent from "../Authors/AuthorsComponent";

import { TTP_API_URL } from "Config";
import styles from "./Article.local.scss";
import classnames from "classnames";
import { getDateLabel } from "Utils";

export default class ArticleComponent extends PureComponent {
  getMainMedia() {
    const { main_media, albums } = this.props.article;

    if (
      albums &&
      albums.length > 0 &&
      albums[0].medias &&
      albums[0].medias.length > 0
    ) {
      const media = { ...albums[0].medias[0] };
      return media.preview &&
        (media.preview.fullMediaUrl || media.preview.webPath)
        ? media.preview.fullMediaUrl
          ? media.preview.fullMediaUrl
          : `${TTP_API_URL}/${media.preview.webPat}`
        : media.fullMediaUrl
          ? media.fullMediaUrl
          : `${TTP_API_URL}/${media.webPath}`;
    }

    if (main_media) {
      if (
        main_media.preview &&
        (main_media.preview.fullMediaUrl || main_media.preview.webPath)
      ) {
        return main_media.preview.fullMediaUrl
          ? main_media.preview.fullMediaUrl
          : TTP_API_URL + "/" + main_media.preview.webPath;
      } else {
        if (main_media.fullCroppedWebPath) {
          return main_media.fullCroppedWebPath;
        } else {
          return main_media.fullMediaUrl
            ? main_media.fullMediaUrl
            : `${TTP_API_URL}/${main_media.webPath}`;
        }
      }
    }
    return "/img/article-cover-small.jpg";
  }

  /*renderAlbum() {
    const { albums } = this.props.article;
    const medias = albums[0].medias;

    let hide = medias.length === 1 ? "hide" : "";

    const settings = {
      dots: true,
      dotsClass: "slick-dots " + hide,
      infinite: true,
      arrows: false,
      speed: 500,
      autoplay: true
    };

    return (
      <div className={styles.media}>
        <Slider {...settings}>
          {medias.map(media => {
            const path =
              media.preview &&
              (media.preview.fullMediaUrl || media.preview.webPath)
                ? media.preview.fullMediaUrl
                  ? media.preview.fullMediaUrl
                  : `${TTP_API_URL}/${media.preview.webPat}`
                : media.fullMediaUrl
                  ? media.fullMediaUrl
                  : `${TTP_API_URL}/${media.webPath}`;
            return (
              <div
                key={`slide-${media.id}`}
                style={{
                  background: `url(${path}) no-repeat center center`,
                  backgroundSize: "cover",
                  width: "100%",
                  height: "11.75rem"
                }}
              />
            );
          })}
        </Slider>
      </div>
    );
  }*/

  render() {
    const { community, article, openArticleReveal, index } = this.props;

    const {
      category,
      language,
      organization,
      title,
      introduction,
      publishedAt,
      author,
      isExternal
    } = article;

    const nameAttr = `name${language.charAt(0).toUpperCase() +
      language.slice(1)}`;

    return (
      <div
        className={classnames(
          styles.article,
          "new-article",
          index === 0 ? styles.big : ""
        )}
      >
        {isExternal ? (
          <div className={styles.externalAvatar}>
            <span>
              <img src="/img/earth.svg" alt="earth" />
            </span>
          </div>
        ) : (
          <AuthorsComponent authors={author ? author : []} />
        )}
        <div className={styles.date}>{getDateLabel(publishedAt)}</div>
        <div
          className={styles.content}
          style={{
            background: `linear-gradient(180deg, rgba(41, 57, 77, 0) 0%, rgba(85, 85, 85, 0.09) 35.42%, rgba(41, 57, 77, 0.72) 67.71%, rgba(41, 57, 77, 0.9) 100%), url(${this.getMainMedia()}) no-repeat center`
          }}
        >
          <div className={styles.category}>
            <span style={{ backgroundColor: category.colorCode }}>
              {category[nameAttr]}
            </span>
          </div>
          <div className={styles.textContent}>
            {organization.id === community.id ? null : (
              <div
                className={styles.community}
                style={{ borderLeftColor: category.colorCode }}
              >
                {organization.abbreviation
                  ? organization.abbreviation
                  : organization.name}
              </div>
            )}
            <div
              className={classnames(
                styles.titleIntro,
                organization.id === community.id ? styles.withoutCom : ""
              )}
            >
              <h4>{title}</h4>
              {index === 0 ? <p>{introduction}</p> : null}
            </div>
            <SocialContainer
              resource={article}
              type="ARTICLE"
              customStyle={3}
            />
          </div>
        </div>
        <div className={styles.cover} onClick={openArticleReveal} />
      </div>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/Article/ArticleComponent.js